<button mat-raised-button color="primary" (click)="impersonateAccount()">
    <mat-icon class="mat-icon material-icons mat-icon-small">perm_identity</mat-icon>
    {{'IMPERSONATE' | translate}}
</button>